module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('blockquote', [_c('blockquote', [_c('blockquote', [_c('p', {
    staticClass: "parac"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A THOMAS DUNNE BOOK FOR MINOTAUR BOOKS.")]), _c('br'), _vm._v("An imprint of St. Martin’s Publishing Group.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "parac"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CITY OF DRAGONS")]), _vm._v(". Copyright © 2010 by Kelli Stanley. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_c('a', {
    attrs: {
      "href": "http://www.thomasdunnebooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.thomasdunnebooks.com")]), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.minotaurbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.minotaurbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_vm._v("Design by Kathryn Parise")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "parac"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "parac"
  }, [_vm._v("Stanley, Kelli.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-parac"
  }, [_vm._v("City of dragons / Kelli Stanley. — 1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-parac"
  }, [_vm._v("      p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-parac"
  }, [_vm._v("“A Thomas Dunne book.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-parac"
  }, [_vm._v("ISBN 978-0-312-60360-1")]), _vm._v(" "), _c('p', {
    staticClass: "parac"
  }, [_vm._v("  1. Women private investigators—California—Fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "parac"
  }, [_vm._v("2. San Francisco (Calif.)—History—20th century—"), _c('br'), _vm._v("Fiction. 3. Chinatown (San Francisco, Calif.)—Fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "parac"
  }, [_vm._v("I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-parac"
  }, [_vm._v("PS3619.T3657C58    2010")]), _vm._v(" "), _c('p', {
    staticClass: "indent-parac"
  }, [_vm._v("813'.6—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("2009039817")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_vm._v("First Edition: February 2010")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_vm._v("10  9  8  7  6  5  4  3  2  1")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 69
// module chunks = 0